import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormControl, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef,} from '@angular/material/dialog';
import {Observable, pairwise, tap} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MainDataModels} from 'src/app/models/maindata-models';
import {ObjektModels} from 'src/app/models/objekt-models';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {v4 as uuidv4} from 'uuid';
import {ObjektAdresseComponent} from '../../objekte/objekt-adresse/objekt-adresse.component';
import {UserAuthenticationService} from 'src/app/services/user-authentication.service';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import moment from "moment";

@Component({
    selector: 'app-aufgabe-eintrag',
    templateUrl: './aufgabe-eintrag.component.html',
    styleUrls: ['./aufgabe-eintrag.component.scss'],
})
export class AufgabeEintragComponent implements OnInit {
    @Input() formGroupAufgabe: UntypedFormGroup;
    public cardTitle = 'MAIN_APP_PENDENZEN.neueAufgabe';
    objekte: Array<MainDataModels.SearchFieldResponseObjekt> = []; // Leeres Objekte-Array erstellen (SearchFieldResponseObjekt[])
    filteredDescriptions?: Observable<MainDataModels.SearchFieldResponseObjekt[]>;
    public percentValue = 0;
    public innerWidth: any;
    isLandscape = false;
    /* Mitarbeiterauswahl (event. mit Gruppen) */
    public dbMitarbeiter?: MainDataModels.Mitarbeiter[];
    public dbKategorien?: MainDataModels.Kategorie[];
    public dbStatus: MainDataModels.TerminStatus[] = [
        {name: 'Nicht begonnen', status: 0},
        {name: 'In Bearbeitung', status: 1},
        {name: 'Erledigt', status: 2},
        {name: 'Wartet auf jemand anderes', status: 3},
        {name: 'Zurückgestellt', status: 4},
    ];
    public dbImportance: MainDataModels.AufgabeWichtigkeit[] = [
        {id: 0, name: 'tief'},
        {id: 1, name: 'normal'},
        {id: 2, name: 'hoch'},
    ];
    /* Objekt-Adressen */
    public objectAddresses: MainDataModels.ObjektAdresseSlim[] = [];
    public objIsChosen = false;
    private readonly currAufgabeMitBenutzer?: MainDataModels.AufgabeMitBenutzer;
    private percentValueBefore = 0;
    private loggedOnUserID = 0;
    private currChosenUserID = 0;
    private objektAdresseDialogInput?: ObjektModels.ObjektAdresseDialogInput;

    constructor(
        private svcMainData: MainDataService,
        private swissSettings: SwissSettingsService,
        private svcObjektData: ObjektDataService,
        private svcMessageBox: MessageBoxService,
        public dialog: MatDialog,
        private userAuthService: UserAuthenticationService,
        public dialogRef: MatDialogRef<AufgabeEintragComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MainDataModels.AufgabeMitBenutzer
    ) {
        if (data) {
            this.currAufgabeMitBenutzer = this.data!;
            if (!this.currAufgabeMitBenutzer.istNeueAufgabe) {
                this.cardTitle = 'Aufgabe bearbeiten';
            }
        } else {
            this.currAufgabeMitBenutzer = MainDataModels.EmptyAufgabeMitBenutzer();
        }

        this.formGroupAufgabe = new UntypedFormGroup({
            fldStatus: new UntypedFormControl(),
            fldWichtigkeit: new UntypedFormControl(),
            fldPrivat: new UntypedFormControl(),
            fldAkzeptiert: new UntypedFormControl(),
            fldKategorie: new UntypedFormControl(),
            fldObjekt: new UntypedFormControl(),
            fldAdresse: new UntypedFormControl(),
            fldTitel: new UntypedFormControl(),
            fldBeschreibung: new UntypedFormControl(),
            fldStartDatum: new UntypedFormControl(),
            fldFaelligDatum: new UntypedFormControl(),
            fldReminder: new FormControl<boolean>(false),
            fldErinnerungDatum: new UntypedFormControl(),
            fldErinnerungZeit: new UntypedFormControl(),
            fldVorgabezeit: new UntypedFormControl(),
            fldErledigt: new UntypedFormControl(),
            fldErledigtProzent: new UntypedFormControl(),
            fldMitarbeiter: new UntypedFormControl(),
        });

        this.formGroupAufgabe.controls['fldWichtigkeit'].setValue(this.currAufgabeMitBenutzer.aufgabe.importance);
        this.formGroupAufgabe.controls['fldStatus'].setValue(this.currAufgabeMitBenutzer.aufgabe.status);
        this.formGroupAufgabe.controls['fldReminder'].valueChanges.pipe(
            takeUntilDestroyed(),
            tap((val) => {
                if (val) {
                    const reminderDate = this.formGroupAufgabe.get('fldErinnerungDatum')?.value;
                    const reminderTime = this.formGroupAufgabe.get('fldErinnerungZeit')?.value;
                    const startDate = this.formGroupAufgabe.get('fldStartDatum')?.value;
                    if (startDate) {
                        if (!reminderDate) {
                            this.formGroupAufgabe.controls['fldErinnerungDatum'].setValue(startDate);
                        }
                        if (!(reminderTime?.trim())) {
                            this.formGroupAufgabe.controls['fldErinnerungZeit'].setValue('08:00');
                        }
                    }
                    this.formGroupAufgabe.controls['fldErinnerungDatum'].enable();
                    this.formGroupAufgabe.controls['fldErinnerungZeit'].enable();
                } else {
                    this.formGroupAufgabe.controls['fldErinnerungDatum'].disable();
                    this.formGroupAufgabe.controls['fldErinnerungZeit'].disable();
                }
            })).subscribe();

        this.formGroupAufgabe.controls['fldStartDatum'].valueChanges.pipe(
            takeUntilDestroyed(),
            startWith(moment(this.currAufgabeMitBenutzer.aufgabe.startdate)),
            pairwise(),
            tap(([prev, newVal]: [any, any]) => {
                if (moment.isMoment(newVal)) {
                    if (newVal.isAfter(this.formGroupAufgabe.controls['fldFaelligDatum'].value)) {
                        this.formGroupAufgabe.controls['fldFaelligDatum'].setValue(newVal);
                    }
                    if ((this.formGroupAufgabe.get('fldReminder')?.value === false || moment(prev).isSame(this.formGroupAufgabe.controls['fldErinnerungDatum'].value)) &&
                        newVal.isBefore(this.formGroupAufgabe.controls['fldErinnerungDatum'].value)) {
                        this.formGroupAufgabe.controls['fldErinnerungDatum'].setValue(newVal);
                    }
                }
            })
        ).subscribe();

        this.formGroupAufgabe.controls['fldFaelligDatum'].valueChanges.pipe(
            takeUntilDestroyed(),
            tap((val) => {
                if (moment.isMoment(val)) {
                    if (val.isBefore(this.formGroupAufgabe.controls['fldStartDatum'].value)) {
                        this.formGroupAufgabe.controls['fldStartDatum'].setValue(val);
                    }
                }
            })
        ).subscribe();

        if (this.data.aufgabe.objectID) {
            this.selectedSearchItem({option: {value: {objectID: this.data.aufgabe.objectID}}});
            this.formGroupAufgabe.controls['fldObjekt'].setValue(this.data.aufgabe.objectID);
        }
    }

    ngOnInit(): void {
        if (!(this.data as any).position?.top) {
            this.dialogRef.updatePosition({top: '3.75rem'});
        }
        this.innerWidth = window.innerWidth;
        this.isLandscape = window.matchMedia('(orientation: landscape)').matches;
        this.refreshSuchfeldBeschreibungen().then(() => {
            // Mitarbeiter laden
            if (this.data.aufgabe.objectID) {
                const obj = this.objekte.find(obj => obj.objectID == this.data.aufgabe.objectID);
                if (obj) {
                    this.selectedSearchItem({option: {value: {objectID: this.data.aufgabe.objectID}}});
                    this.formGroupAufgabe.controls['fldObjekt'].setValue(obj);
                }
            }
            this.svcMainData.getMitarbeiterWithDB().then((res) => {
                this.dbMitarbeiter = res.filter((mi) => mi.active === 1).sort(
                    (a, b) =>
                        (a.loginname.toLocaleLowerCase() >
                            b.loginname.toLocaleLowerCase() &&
                            1) ||
                        -1
                );
                this.loadFieldValues();
            });

            // Termin-Kategorien laden
            this.svcMainData.getKategorienWithDB().then((res) => {
                this.dbKategorien = res;
            });

            this.filteredDescriptions = this.formGroupAufgabe.controls[
                'fldObjekt'
                ].valueChanges.pipe(
                startWith(''),
                map((value) => this._filter(value))
            );
        });
    }

    getObjektDesc(item: MainDataModels.SearchFieldResponseObjekt) {
        if (item) {
            return item.beschreibung;
        } else {
            return '';
        }
    }

    updatePercentValue(event: any) {
        this.percentValue = event.value;
    }

    changeDone(event: MatCheckboxChange) {
        if (event.checked) {
            this.percentValueBefore = this.percentValue;
            this.percentValue = 100;
        } else {
            this.percentValue = this.percentValueBefore;
        }
        console.log('Event: ', event);
    }

    // Suchelement wurde angeklickt
    selectedSearchItem(event: any) {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log(event.option.value);
        }
        if (event) {
            this.currAufgabeMitBenutzer!.aufgabe.objectID = event.option.value.objectID;
            this.objIsChosen = true;
            this.svcMainData.getTerminObjektAdressen(this.currAufgabeMitBenutzer!.aufgabe.objectID)
                .subscribe({
                    next: (res) => {
                        if (res) {
                            this.objectAddresses = res;
                            if (this.objectAddresses.length > 0) {
                                this.currAufgabeMitBenutzer!.aufgabe.adressID = this.objectAddresses[0].adressID;
                                this.formGroupAufgabe.controls['fldAdresse'].setValue(this.objectAddresses[0]);
                            }
                        }
                    },
                });
        }
    }

    selectedAdress(event: any) {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log(event);
        }
        if (event) {
            this.currAufgabeMitBenutzer!.aufgabe.adressID = event.value.adressID;
        }
    }

    refreshSuchfeldBeschreibungen(): Promise<boolean> {
        return new Promise((resolve) => {
            this.objekte = [];
            this.svcObjektData.getSuchfeldBeschreibungen().subscribe({
                next: (res) => {
                    this.objekte = this.objekte.concat(res);
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log('Geladene Objekte', this.objekte);
                    }
                    resolve(true);
                },
            });
        });
    }

    async save(): Promise<void> {
        if (!this.currAufgabeMitBenutzer) {
            throw new Error('Aufgabe-Objekt ist nicht vorhanden');
        }
        if (!this.dbKategorien) {
            throw new Error('Kategorien sind nicht vorhanden');
        }
        if (!this.dbMitarbeiter) {
            throw new Error('Mitarbeiter sind nicht vorhanden');
        }

        try {
            if (this.formGroupAufgabe.value) {
                // Status
                this.currAufgabeMitBenutzer.aufgabe.status = this.formGroupAufgabe.controls['fldStatus'].value;

                // Wichtigkeit
                this.currAufgabeMitBenutzer.aufgabe.importance = this.formGroupAufgabe.controls['fldWichtigkeit'].value;

                this.currAufgabeMitBenutzer.aufgabe.reminder = this.formGroupAufgabe.controls['fldReminder'].value ? 1 : 0;

                // Kategorie(n)
                const kategorien = this.formGroupAufgabe.controls['fldKategorie'].value;
                this.currAufgabeMitBenutzer.aufgabeKategorien = [];

                if (kategorien) {
                    for (const element of kategorien) {
                        const kat = this.dbKategorien.find((tk) => tk.id === element);
                        if (!kat) {
                            throw new Error('Kategorie ' + element + ' nicht gefunden');
                        }
                        const tkz: MainDataModels.AufgabeKategorieZuord = {
                            id: uuidv4(),
                            taskID: this.currAufgabeMitBenutzer.aufgabe.taskUID,
                            categoryID: kat?.id,
                        };
                        this.currAufgabeMitBenutzer.aufgabeKategorien.push(tkz);
                    }
                }

                // Privat
                this.currAufgabeMitBenutzer.aufgabe.private = this.formGroupAufgabe.controls['fldPrivat'].value ? 1 : 0;

                // Akzeptiert
                this.currAufgabeMitBenutzer.aufgabe.accepted = (this.formGroupAufgabe.controls['fldAkzeptiert'].value === true || this.formGroupAufgabe.controls['fldAkzeptiert'].value === 1) ? 1 : 0;

                // Gelesen
                this.currAufgabeMitBenutzer.aufgabe.wasRead = this.currChosenUserID === this.loggedOnUserID ? 1 : 0;

                // Adresse
                const adresse = this.formGroupAufgabe.controls['fldAdresse'].value;
                if (adresse) {
                    this.currAufgabeMitBenutzer.aufgabe.adressID = adresse.adressID;
                }

                // Mitarbeiter
                const mitarbeiter: number[] = this.formGroupAufgabe.controls['fldMitarbeiter'].value;
                this.currAufgabeMitBenutzer.mitarbeiter = this.dbMitarbeiter.filter((mi) => mitarbeiter.includes(mi.userID));

                // Titel
                this.currAufgabeMitBenutzer.aufgabe.description = this.formGroupAufgabe.controls['fldTitel'].value;

                // Beschreibung
                const noteText = this.formGroupAufgabe.controls['fldBeschreibung'].value;
                this.currAufgabeMitBenutzer.aufgabe.notes = typeof noteText === 'string'
                    ? noteText.replace(/\r\n|\r|\n/g, '\r\n')
                    : noteText;

                // Beginnt am-Datum
                this.currAufgabeMitBenutzer.aufgabe.startdate = this.formGroupAufgabe.controls['fldStartDatum'].value;

                // Fällig am-Datum
                this.currAufgabeMitBenutzer.aufgabe.dueDate = this.formGroupAufgabe.controls['fldFaelligDatum'].value;

                this.currAufgabeMitBenutzer.aufgabe.reminder = this.formGroupAufgabe.controls['fldReminder'].value ? 1 : 0;

                // Erinnerung-Datum
                this.currAufgabeMitBenutzer.aufgabe.reminderDate = this.formGroupAufgabe.controls['fldErinnerungDatum'].value;

                // Erinnerung-Zeit
                this.currAufgabeMitBenutzer.aufgabe.reminderTime = this.formGroupAufgabe.controls['fldErinnerungZeit'].value;

                // Vorgabezeit
                this.currAufgabeMitBenutzer.aufgabe.maxTime = this.formGroupAufgabe.controls['fldVorgabezeit'].value;

                // Erledigt
                this.currAufgabeMitBenutzer.aufgabe.done = this.formGroupAufgabe.controls['fldErledigt'].value;

                // Erledigt in Prozent
                this.currAufgabeMitBenutzer.aufgabe.percentDone = this.percentValue;
            }

            this.dialogRef.close(this.currAufgabeMitBenutzer);
        } catch (ex) {
            this.svcMessageBox.showErrorByLanguageKey('MAIN_APP.', '');
        }
    }

    addObjectAddress() {
        if (this.objIsChosen) {
            this.objektAdresseDialogInput = {
                objektAdresseZuord: {
                    id: '00000000-0000-0000-0000-000000000000',
                    objectID: this.currAufgabeMitBenutzer!.aufgabe!.objectID,
                    addressType: 5, // Diverses
                    addressContact: 0,
                    adressNumber: 0,
                    adressID: '',
                },
                blDoCheckUnique: true,
                blDisableAdrTypeSelect: false,
            };
            var dialogRef = this.dialog.open(ObjektAdresseComponent, {
                disableClose: true,
                width: '95%',
                data: this.objektAdresseDialogInput,
            });

            dialogRef.afterClosed().subscribe({
                next: (result) => {
                    if (result) {
                        this.objektAdresseDialogInput!.objektAdresseZuord = result;
                        if (this.objektAdresseDialogInput!.objektAdresseZuord) {
                            this.svcObjektData
                                .addObjectAddress(
                                    this.objektAdresseDialogInput!.objektAdresseZuord
                                )
                                .subscribe({
                                    next: () => {
                                        this.loadObjectAdressen(
                                            this.objektAdresseDialogInput!.objektAdresseZuord.adressID
                                        );
                                        this.currAufgabeMitBenutzer!.aufgabe!.adressID =
                                            this.objektAdresseDialogInput!.objektAdresseZuord.adressID;
                                        if (
                                            this.objektAdresseDialogInput!.objektAdresseZuord
                                                .contactID
                                        ) {
                                            this.currAufgabeMitBenutzer!.aufgabe!.contactID =
                                                this.objektAdresseDialogInput!.objektAdresseZuord.contactID;
                                        }
                                    },
                                    error: (err) => console.error('Fehler: ', err),
                                });
                        }
                    }
                },
            });
        } else {
            this.svcMessageBox.showWarning('Objekt muss zuvor ausgewählt werden', '!! Warnung !!');
        }
    }

    private loadFieldValues() {
        // Felder abfüllen
        if (!this.currAufgabeMitBenutzer || !this.currAufgabeMitBenutzer.aufgabe) {
            throw new Error('Aufgabe-Objekt ist nicht vorhanden');
        }

        this.formGroupAufgabe.controls['fldReminder'].setValue(this.currAufgabeMitBenutzer.aufgabe.reminder);
        // Neue Aufgabe
        if (this.currAufgabeMitBenutzer.istNeueAufgabe) {
            if (this.currAufgabeMitBenutzer.aufgabe.startdate) {
                this.formGroupAufgabe.get('fldStartDatum')!.setValue(this.currAufgabeMitBenutzer.aufgabe.startdate);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.dueDate) {
                this.formGroupAufgabe.get('fldFaelligDatum')!.setValue(this.currAufgabeMitBenutzer.aufgabe.dueDate);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.responsible) {
                const mitarbeiter = this.dbMitarbeiter?.find((x) => x.loginname == this.currAufgabeMitBenutzer!.aufgabe.responsible);
                if (mitarbeiter) {
                    this.loggedOnUserID = mitarbeiter.userID;
                    this.currChosenUserID = this.loggedOnUserID;
                    this.setAkzeptiertDisabled();
                }
                if (mitarbeiter) {
                    this.formGroupAufgabe.get('fldMitarbeiter')!.setValue([mitarbeiter.userID]);
                }
                this.formGroupAufgabe.get('fldStatus')!.setValue(this.currAufgabeMitBenutzer.aufgabe.status);
                this.formGroupAufgabe.get('fldWichtigkeit')!.setValue(this.currAufgabeMitBenutzer.aufgabe.importance);
                if (this.currAufgabeMitBenutzer.aufgabe.accepted === 1) {
                    this.formGroupAufgabe.get('fldAkzeptiert')!.setValue(1);
                }
            }

            if (this.currAufgabeMitBenutzer!.aufgabe.objectID != '') {
                this.objIsChosen = true;
                this.formGroupAufgabe.get('fldObjekt')!.setValue(
                    this.objekte.filter(
                        (o) =>
                            o.objectID === this.currAufgabeMitBenutzer!.aufgabe.objectID
                    )[0]
                );
                this.loadObjectAdressen();
            }
        } else {
            const user = this.userAuthService.getCurrentAuthenticatedUser();
            if (user) {
                this.loggedOnUserID = user!.userID;
            }

            // Bestehende Aufgabe bearbeiten
            this.formGroupAufgabe.get('fldStatus')!.setValue(this.currAufgabeMitBenutzer.aufgabe.status);
            this.formGroupAufgabe.get('fldWichtigkeit')!.setValue(this.currAufgabeMitBenutzer.aufgabe.importance);

            if (this.currAufgabeMitBenutzer.aufgabeKategorien) {
                let katis: number[] = [];
                this.currAufgabeMitBenutzer.aufgabeKategorien.forEach((ak) => {
                    katis.push(ak.categoryID);
                });
                this.formGroupAufgabe.get('fldKategorie')!.setValue(katis);
            }

            if (this.currAufgabeMitBenutzer.aufgabe.private === 1) {
                this.formGroupAufgabe.get('fldPrivat')!.setValue(1);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.accepted === 1) {
                this.formGroupAufgabe.get('fldAkzeptiert')!.setValue(1);
            }

            this.formGroupAufgabe.get('fldObjekt')!.setValue(
                this.objekte.filter(
                    (o) =>
                        o.objectID === this.currAufgabeMitBenutzer!.aufgabe.objectID
                )[0]
            );
            this.objIsChosen = true;
            this.loadObjectAdressen(this.currAufgabeMitBenutzer.aufgabe.adressID);

            if (this.currAufgabeMitBenutzer.aufgabe.description) {
                this.formGroupAufgabe.get('fldTitel')!.setValue(this.currAufgabeMitBenutzer.aufgabe.description);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.notes) {
                this.formGroupAufgabe.get('fldBeschreibung')!.setValue(this.currAufgabeMitBenutzer.aufgabe.notes);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.startdate) {
                this.formGroupAufgabe.get('fldStartDatum')!.setValue(this.currAufgabeMitBenutzer.aufgabe.startdate);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.dueDate) {
                this.formGroupAufgabe.get('fldFaelligDatum')!.setValue(this.currAufgabeMitBenutzer.aufgabe.dueDate);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.reminderDate) {
                this.formGroupAufgabe.get('fldErinnerungDatum')!.setValue(this.currAufgabeMitBenutzer.aufgabe.reminderDate);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.reminderTime) {
                this.formGroupAufgabe.get('fldErinnerungZeit')!.setValue(this.currAufgabeMitBenutzer.aufgabe.reminderTime);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.maxTime) {
                this.formGroupAufgabe.get('fldVorgabezeit')!.setValue(this.currAufgabeMitBenutzer.aufgabe.maxTime);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.done) {
                this.formGroupAufgabe.get('fldErledigt')!.setValue(1);
            }
            if (this.currAufgabeMitBenutzer.aufgabe.percentDone) {
                this.formGroupAufgabe.get('fldErledigtProzent')!.setValue(this.currAufgabeMitBenutzer.aufgabe.percentDone);
                this.percentValue = this.currAufgabeMitBenutzer.aufgabe.percentDone;
            }

            if (
                this.currAufgabeMitBenutzer.mitarbeiter &&
                this.currAufgabeMitBenutzer.mitarbeiter.length === 1
            ) {
                this.formGroupAufgabe.get('fldMitarbeiter')!.setValue(this.currAufgabeMitBenutzer.mitarbeiter.map(emp => emp.userID));
                this.currChosenUserID = this.currAufgabeMitBenutzer.mitarbeiter[0].userID;
                this.setAkzeptiertDisabled();
            }
        }

    }

    private loadObjectAdressen(adresseID: string = '') {
        this.svcMainData
            .getTerminObjektAdressen(this.currAufgabeMitBenutzer!.aufgabe.objectID)
            .subscribe({
                next: (res) => {
                    if (res) {
                        this.objectAddresses = res;
                        if (adresseID) {
                            let objAdr = this.objectAddresses.filter(
                                (oa) =>
                                    oa.adressID === this.currAufgabeMitBenutzer!.aufgabe.adressID
                            )[0];
                            this.formGroupAufgabe.get('fldAdresse')!.setValue(objAdr);
                        } else {
                            // Wenn nur eine Adresse existiert, dann diese vorselektieren
                            if (this.objectAddresses.length === 1) {
                                this.formGroupAufgabe.get('fldAdresse')!.setValue(this.objectAddresses[0]);
                            } else if (this.objectAddresses.length > 1) {
                                // Wenn es mehr als eine Kundenadresse hat --> gibt es eine Kundenadresse?
                                // Wenn ja, vorselektieren!
                                let objAdr = this.objectAddresses.filter(
                                    (oa) => oa.typ === 1
                                )[0];
                                if (objAdr) {
                                    this.formGroupAufgabe.get('fldAdresse')!.setValue(objAdr);
                                }
                            }
                        }
                    }
                },
            });
    }

    private _filter(value: string): MainDataModels.SearchFieldResponseObjekt[] {
        if (value) {
            const filterValue = value.toLowerCase();

            if (this.objekte && this.objekte.length > 0) {
                // Sternsuche
                if (filterValue.length > 1 && filterValue[0] === '*') {
                    const searchValue = filterValue.substring(1, filterValue.length);
                    return this.objekte.filter(
                        (objekt) =>
                            objekt.beschreibung &&
                            objekt.beschreibung.toLowerCase().indexOf(searchValue) >= 0
                    );
                } else {
                    return this.objekte.filter(
                        (objekt) =>
                            objekt.beschreibung &&
                            objekt.beschreibung.toLowerCase().indexOf(filterValue) === 0
                    );
                }
            } else {
                return this.objekte;
            }
        } else {
            return [];
        }
    }

    private setAkzeptiertDisabled() {
        if (this.currChosenUserID === this.loggedOnUserID) {
            this.formGroupAufgabe.controls['fldAkzeptiert'].disable();
        }
    }
}
